import { Type } from 'class-transformer';
import { IsEnum, IsNumber, IsObject, IsOptional, IsString } from 'class-validator';

import type {
  EnqueuedWorkflowExecution,
  Schedule,
} from '../interfaces/enqueued-workflow-execution.interface';

export class EnqueuedWorkflowExecutionDto implements EnqueuedWorkflowExecution {
  @IsNumber()
  customerId!: number;

  @IsString()
  workflowName!: string;

  @IsOptional()
  @IsString()
  cron?: string;

  @IsEnum(['CRON', 'IMMEDIATE', 'DAILY', 'WEEKLY', 'MONTHLY'])
  schedule!: Schedule;

  @IsOptional()
  @IsObject()
  @Type(() => Object)
  configuration?: object;

  @IsOptional()
  @IsString()
  configurationLink?: string;
}
